import script from "./EditFloorPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./EditFloorPlan.vue?vue&type=script&setup=true&lang=js"

import "./EditFloorPlan.vue?vue&type=style&index=0&id=5f6a9b02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6a9b02"]])

export default __exports__